import { Invoice, invoiceCalculations } from "modules/invoice";
import { FinanceProgramFormValues } from "../types";

export function convertInvoiceToSaleDetailsFormValues(
  invoice: Invoice
): Omit<FinanceProgramFormValues["saleDetails"], "saleType"> {
  const { invoiceTotal, netFinanceAmount, netTrade, totalFees } = invoiceCalculations.byInvoice(invoice);

  return {
    fees: totalFees,
    netRate: netTrade,
    invoiceTotal: invoiceTotal,
    financeAmount: netFinanceAmount,
    downPayment: invoice.downPayment,
    salesTax: invoice.salesTaxOnInvoice,
    equipmentSubtotal: invoice.equipmentCost,
  };
}
